export var FilterTypes;
(function (FilterTypes) {
    FilterTypes["DateRanges"] = "Date Range";
    FilterTypes["SingleKeys"] = "Single Key";
    FilterTypes["SingleValues"] = "Single Value";
})(FilterTypes || (FilterTypes = {}));
export var FilterOptionTypes;
(function (FilterOptionTypes) {
    FilterOptionTypes["Key"] = "key";
    FilterOptionTypes["FilterType"] = "filterType";
    FilterOptionTypes["Operation"] = "operation";
})(FilterOptionTypes || (FilterOptionTypes = {}));
